<jhi-modal [title]="title">
    <div class="modal-body">
        <div class="row pt-2">
            <div class="col"><span class="fw-bold">{{ 'study-editor.study-dataset.import-study-choose-dataset-modal.dataset' | translate | uppercase}}</span></div>
        </div>
        <div class="row pt-2">
            <div class="col">
                <span>{{description}}</span>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col">
                <ng-select [items]="datasets" [(ngModel)]="selectedDatasetType" [compareWith]="compareByDatasetId"
                           [bindValue]="null" [bindLabel]="null" [clearable]="false" required>
                    <ng-template ng-label-tmp let-item="item">
                        {{ item.name }}
                        @if (getDatasetType(item.datasetTypeId)) {
                            <span class="badge badge-pill text-bg-secondary">{{ getDatasetType(item.datasetTypeId)?.tabNamePrefix | translate }}</span>
                        }
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        {{ item.name }}
                        @if (getDatasetType(item.datasetTypeId)) {
                            <span class="badge badge-pill text-bg-secondary">{{ getDatasetType(item.datasetTypeId)?.tabNamePrefix | translate }}</span>
                        }
                    </ng-template>
                </ng-select>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dismiss()">
            <span class="fa fa-ban"></span>&nbsp;<span translate="cancel"></span>
        </button>
        <button (click)="continue()" class="btn btn-primary" data-test="modalConfirmButton">
            <span translate="continue"></span>
        </button>
    </div>
</jhi-modal>
